import { ButtonIcon } from '@backstage/ui';
import { Icon } from '@iconify/react';

import classes from './HomeCardPagination.module.css';

type Props = {
  currentPage: number;
  onPageChange: (page: number) => void;
  pageSize: number;
  totalItems: number;
};

export const HomeCardPagination = ({ currentPage, onPageChange, pageSize, totalItems }: Props) => {
  const totalPages = pageSize > 0 ? Math.ceil(totalItems / pageSize) : 0;
  const startItem = totalItems === 0 || pageSize === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  return (
    <div className={classes.root}>
      <span aria-live="polite" className={classes.range}>
        {`${startItem}\u{2013}${endItem} of ${totalItems}`}
      </span>
      <ButtonIcon
        aria-label="Previous page"
        icon={<Icon icon="ri:arrow-left-s-line" />}
        isDisabled={currentPage === 1}
        onPress={() => onPageChange(currentPage - 1)}
        variant="secondary"
      />
      <ButtonIcon
        aria-label="Next page"
        icon={<Icon icon="ri:arrow-right-s-line" />}
        isDisabled={currentPage >= totalPages}
        onPress={() => onPageChange(currentPage + 1)}
        variant="secondary"
      />
    </div>
  );
};
